<button *ngIf="userService?.hasRole[Roles?.GeneralLedgerAdmin]" pButton type="button" class="action-secondary" icon="fa fa-gear" label="Manage Legacy Invoices"
        pTooltip="Manage Legacy Invoices" tooltipPosition="top" (click)="onClickManageInvoiceDialog()">
</button>


<p-dialog [(visible)]="displayLegacyInvoiceDialog"
          header="Manage Legacy Invoices" [modal]="true" [dismissableMask]="true" [responsive]="true" [style]="PrimeNgConfig.DialogStyle90">

  <app-data-table #dt [columns]="tableColumns" [value]="existingInvoices" [rightCaptionTemplate]="rightCaptionTemplate">
    <ng-template #rightCaptionTemplate let-row="row">
            <div class="excelContainer">
              <span>Excel</span>
              <app-excel-file-load styleClass="excelUpload" tooltip="Upload Excel file to load Invoices from legacy system awaiting payments"
                                   (handleAfterLoad)="onSelectConvertToInvoices($event)">
              </app-excel-file-load>
              <button pButton class="icon-action" icon="fa fa-download" pTooltip="Download the Excel template to load Invoices from legacy system awaiting payments" tooltipPosition="top"
                      (click)="onClickDownloadExcelTemplate()">
              </button>
            </div>


      <button pButton class="icon-action" icon="fa fa-plus" pTooltip="Add New legacy invoice" tooltipPosition="top"
              (click)="onClickAddNewInvoice()">
      </button>
    </ng-template>

    <ng-template #actionTemplate let-row="row">
      <button [disabled]="!row.invoiceId || row?.balanceDue == 0"
              pButton class="icon-action" icon="fa fa-usd"
              (click)="onClickShowPayment(row)">
      </button>
    </ng-template>
  </app-data-table>


  <p-footer>
    <div style="text-align:right;">
      <button pButton class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="displayLegacyInvoiceDialog=false"></button>
    </div>
  </p-footer>
</p-dialog>

<p-dialog *ngIf="selectedInvoiceToEdit" [(visible)]="displayEditInvoiceDialog"
          header="Legacy Invoice"
          [dismissableMask]="true" [responsive]="true"
          [modal]="true" [style]="PrimeNgConfig.DialogStyle40">
  <form #dialogForm="ngForm">
    <div class="p-grid">


      <div class="p-col-12 p-md-4 p-lg-4">
        <label *ngIf="transaction === Transaction.VendorInvoice">Vendor*</label>
        <label *ngIf="transaction === Transaction.CustomerInvoice">Customer*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown name="dependentType" [placeholder]="PrimeNgConfig.DropdownPlaceholder"
                    [options]="partnersDropDown" [(ngModel)]="selectedInvoiceToEdit.vendorOrCustomerId"
                    required></p-dropdown>
      </div>


      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Reference*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <input pInputText name="invoice" type="text"
               [(ngModel)]="selectedInvoiceToEdit.referenceNumber" required/>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Invoice Date*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="invoiceDate" dataType="string" [dateFormat]="Format.PcalendarDate" [showIcon]="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
                    [(ngModel)]="selectedInvoiceToEdit.invoiceDate"></p-calendar>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Due Date*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="dueDate" dataType="string" [dateFormat]="Format.PcalendarDate" [showIcon]="true"
                    [monthNavigator]="true" [yearNavigator]="true" [yearRange]="yearRange"
                    [(ngModel)]="selectedInvoiceToEdit.dueDate"></p-calendar>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Invoice Amount Due*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <span class="p-inputgroup">
          <span class="p-inputgroup-addon">$</span>
          <input name="invoiceAmountDue" type="number"
                 [pattern]="RegExp12DigitInteger2DigitFraction" pKeyFilter="pnum"
                 [maxLength]="Validation.AmountMaxLength"
                 [(ngModel)]="selectedInvoiceToEdit.invoiceAmountDue" required>
        </span>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Balance Due*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <span class="p-inputgroup">
          <span class="p-inputgroup-addon">$</span>
          <input name="invoiceAmountDue" type="number"
                 [pattern]="RegExp12DigitInteger2DigitFraction" pKeyFilter="pnum"
                 [maxLength]="Validation.AmountMaxLength"
                 [(ngModel)]="selectedInvoiceToEdit.balanceDue" required>
        </span>
      </div>
    </div>
  </form>


  <p-footer>
    <div class="ui-dialog-buttonpane ui-helper-clearfix">
      <!-- disable it until all required field including chargeCodeId are selected -->
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel" (click)="displayEditInvoiceDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add" (click)="onClickSaveInvoice()" [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="fa fa-info" key="legacyInvoice"></p-confirmDialog>

